
import { useMobileMenu as useContextMobileMenu } from "@/contexts/MobileMenuContext";

export const useMobileMenu = useContextMobileMenu;
